import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import "../../../styles/reports/reports.scss";
import "../../../styles/tools/colors.scss";
import { Button } from "react-bootstrap";
import Calendar from "react-calendar/dist/umd/Calendar";
import { apiHost } from "../../../api/apiClient";
import { setLoadingPage, setErrorMessage, setHeaderVisible } from "../../../reducers/actions";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import GridLoader from "react-spinners/GridLoader";
import DropDownSearch from "../../commoncomponents/dropDownSearch";
import MultiDropDown from "../../commoncomponents/multiDropDown";
import TruckSelect from "./truckSelect";
import MultiVisitMap from "../../maps/multiVisitMap";

class Multiasset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataPlaceholder: moment().subtract(1, 'days').format("dddd Do MMMM, YYYY"),
      date: moment().subtract(1, 'days').toDate(),
      calendarShow: false,
      checked: true,
      selectedDate: moment().subtract(1, 'days').format("YYYY-MM-DD"),
      reportLoader: false,
      generatedDate: moment().subtract(1, 'days').format("DD-MMM hh:mm a"),
      selectedGroupName: "Select Group",
      selectGroupId: "",
      groupData: [],
      assetData: [],
      selectAssetData: null,
      finalDataArr: [],
      depots: [],
      redraw: false,
      showContent: false,
      loadedReportParams: null,
      focusedAssetId: "",
      reportVersion: 0,
    };
    this.finalDataArr = [];
    this.colourArr = ["#AF04D6", "#D84A08", "#138ED6", "#09994C", "#CC0066", "#16B8C7", "#00FF00", "#FF9900", "#FFFF00", "#999966"];
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.maxDate = moment().subtract(1, 'days').toDate();
  }

  componentDidMount() {
    this.setGroupList();
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false });
    }
  }

  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };

  onChangeDate = (date) => {
    this.setState({
      date: date,
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      selectedDate: moment(date).format("YYYY-MM-DD"),
      calendarShow: false,
    });
  };

  handleCheckup = () => {
    this.setState({
      checked: !this.state.checked,
    });
  };

  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };

  handleCreateReport = async () => {
    if (!this.canCreateReport()) {
      return;
    }

    this.setState({
      reportLoader: true,
      generatedDate: moment().format("DD-MMM hh:mm a"),
      finalDataArr: [],
      depots: [],
      redraw: true,
      focusedAssetId: "",
    });

    await this.getMultiAssetData();
  };

  getMultiAssetData = async () => {
    try {
      let multiData = await axios.post(
        `${apiHost}/api/Report/map`,
        {
          AssetIds: this.getAssetIds(this.state.selectAssetData), //["08d7c00a-f58f-4d4a-8f29-1b35a4dd9518"], // //  //
          SearchDate: this.state.selectedDate, //"2020-04-01", // //
          Timezone: localStorage.getItem("timeZoneID"),
          UseFiltering: false,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.finalDataArr = [];
      multiData.data.forEach((single, index) => {
        this.createTotalMapData(single, index);
      });
      const depots = multiData.data
        .map((item) => {
          return item.depot;
        })
        .filter((value) => value != null);

      const distinctDepots = depots.filter((depot, index, self) => index === self.findIndex((d) => d.depotId === depot.depotId));
      this.setState((prevState) => ({
        reportLoader: false,
        showContent: true,
        finalDataArr: this.finalDataArr,
        depots: distinctDepots,
        reportVersion: prevState.reportVersion + 1,
        loadedReportParams: {
          groupId: this.state.selectGroupId,
          assetIds: this.getAssetIds(this.state.selectAssetData).join(","),
          reportDate: this.state.selectedDate,
        },
      }));
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
      this.setState({ reportLoader: false });
    }
  };

  colourReturn = (data) => {
    let colourSend = "";
    this.state.selectAssetData.forEach((element) => {
      if (element.id == data.assetId) {
        colourSend = element.colour;
      }
    });
    // console.log("element.colour", colourSend);
    return colourSend;
  };

  createTotalMapData = (data, index) => {
    let color = this.colourReturn(data);

    let finalobj = {
      id: data.assetId,
      colour: color,
      depotName: data.depotName,
    };
    let tripFinalArr = [];

    data.mapObjects.forEach((element) => {
      let singleTripArr = [];

      element.tripMapPoints.forEach((single) => {
        const singleObj = {
          lat: single.latitude,
          lng: single.longitude,
          angle: single.heading,
        };
        singleTripArr.push(singleObj);
      });
      tripFinalArr.push(singleTripArr);
    });
    finalobj.trips = tripFinalArr;

    let subTripArr = [];
    data.tripMapObjects.forEach((subTrip) => {
      const subTripObj = {
        lat: subTrip.lastMessage.gPRMC.latitude,
        lng: subTrip.lastMessage.gPRMC.longitude,
        assetName: subTrip.assetName,
        address: subTrip.address,
        arrived: subTrip.arrived,
        departed: subTrip.departed,
        parked: subTrip.parked,
        name: subTrip.positionName,
        tempA: subTrip.lastMessage.sensorAValue,
        tempB: subTrip.lastMessage.sensorBValue,
        fridge: subTrip.lastMessage.iO1 == 1 ? "On" : "Off",
      };
      subTripArr.push(subTripObj);
    });

    const firstPosition = {
      name: this.testNull(data.startPosition, "positionName"),
      recieved: this.testNull(data.startPosition, "recieved"),
      assetName: this.testNull(data.startPosition, "assetName"),
      address: this.testNull(data.startPosition, "address"),
      parked: this.testNull(data.startPosition, "parked"),
      speed: this.testNull(data.startPosition, "speed"),
      lat: this.testNull(data.startPosition, "latitude"),
      lng: this.testNull(data.startPosition, "longitude"),
    };
    const lastPosition = {
      lat: this.testNull(data.endPosition, "latitude"),
      lng: this.testNull(data.endPosition, "longitude"),
    };

    finalobj.subTrips = subTripArr;
    finalobj.first = firstPosition;
    finalobj.last = lastPosition;
    this.finalDataArr.push(finalobj);
  };

  testNull = (data, value) => {
    if (data && data[value]) {
      let thing = data[value];
      return thing;
    } else {
      return null;
    }
  };

  getAssetIds = (datas) => {
    let returnArr = [];
    datas.forEach((data) => {
      returnArr.push(data.id);
    });
    return returnArr;
  };

  handleGroupSelect = (value) => {
    // console.log("value", value);
    this.setState({
      selectedGroupName: `${value.groupName} - ${value.customername}`,
      selectGroupId: value.groupId,
      selectAssetData: [],
      assetData: [],
    });
    this.setSpecificGroup(value.groupId);
  };

  handleAssetSelect = (data) => {
    data.forEach((single, index) => {
      single.colour = this.colourArr[index];
    });
    this.setState({ selectAssetData: data });
  };

  canCreateReport = () => {
    return !!(this.state.selectGroupId && this.state.selectAssetData && this.state.selectAssetData.length > 0);
  };

  setGroupList = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/Assets/GroupsByCurrentUser`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        this.setState({ groupData: response.data });
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  setSpecificGroup = async (id) => {
    try {
      const response = await axios.get(`${apiHost}/api/Assets/AssetsByCustomerIdWithIMEI?GroupId=${id}&IsReport=true`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        let assetData = [];
        response.data.forEach((element) => {
          const obj = {
            id: element.assetId,
            name: element.assetName,
          };
          assetData.push(obj);
        });
        this.setState({ assetData });
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleTruckSelection = (click, id) => {
    this.setState((prevState) => {
      const selectedAsset = this.finalDataArr.find((item) => item.id === id);
      const finalDataArr = click
        ? selectedAsset
          ? [...prevState.finalDataArr, selectedAsset]
          : prevState.finalDataArr
        : prevState.finalDataArr.filter((item) => item.id !== id);

      return {
        finalDataArr,
        redraw: false,
        focusedAssetId: click ? prevState.focusedAssetId : prevState.focusedAssetId === id ? "" : prevState.focusedAssetId,
      };
    });
  };

  handleAssetTileFocus = (id) => {
    if (!this.mapRef || !this.state.finalDataArr.find((asset) => asset.id === id)) {
      return;
    }

    this.setState({ focusedAssetId: id, redraw: false }, () => {
      this.mapRef.focusAsset(id);
    });
  };

  handleResetMap = () => {
    if (this.mapRef) {
      this.mapRef.resetMapView();
    }

    this.setState({ focusedAssetId: "", redraw: false });
  };

  handlePanelResetMap = (event) => {
    event.stopPropagation();
    this.handleResetMap();
  };

  render() {
    const selectedAssetCount = this.state.selectAssetData ? this.state.selectAssetData.length : 0;
    const canCreateReport = this.canCreateReport();
    const loadedReportParams = this.state.loadedReportParams;
    const hasPendingReportChanges = !!(
      loadedReportParams &&
      canCreateReport &&
      (
        loadedReportParams.groupId !== this.state.selectGroupId ||
        loadedReportParams.assetIds !== this.getAssetIds(this.state.selectAssetData).join(",") ||
        loadedReportParams.reportDate !== this.state.selectedDate
      )
    );

    const calendarReport = this.state.calendarShow ? (
      <div ref={this.setWrapperRef} className="ParentCalender" style={{ position: "relative", zIndex: 100 }}>
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar maxDate={this.maxDate} onChange={this.onChangeDate} value={this.state.date} />
        </div>
      </div>
    ) : (
      ""
    );

    let groupValues = [];
    this.state.groupData.forEach((element) => {
      groupValues.push(element.name);
    });

    const assetMapControls = (
      <div className="multiAssetLegend">
        <div className="multiAssetLegendHeader">
          <div>
            <h3>Asset visibility</h3>
            <p>{selectedAssetCount > 0 ? `${selectedAssetCount} selected asset${selectedAssetCount === 1 ? "" : "s"}` : "Select assets to build the map"}</p>
          </div>
          {this.state.showContent && (
            <button
              type="button"
              className="multiAssetPanelResetButton"
              onClick={this.handlePanelResetMap}
              title="Reset map to selected assets"
            >
              <i className="fa fa-crosshairs"></i>
            </button>
          )}
        </div>
        <div className="truckSelect-container">
          {this.state.selectAssetData != null &&
            this.state.selectAssetData.map((truck) => {
              const routeVisible = !!this.state.finalDataArr.find((asset) => asset.id === truck.id);
              return (
                <TruckSelect
                  key={truck.id}
                  name={truck.value}
                  colour={truck.colour}
                  id={truck.id}
                  active={this.state.focusedAssetId === truck.id}
                  disabled={!this.state.showContent}
                  routeVisible={routeVisible}
                  onTileFocus={this.handleAssetTileFocus}
                  onParentCall={this.handleTruckSelection}
                />
              );
            })}
        </div>
      </div>
    );

    return (
      <Layout>
        <Helmet>
          <title>Multi Asset Visit Report</title>
        </Helmet>
        <div className="contentBody">
          <div className={!this.props.headerHide ? `contentWrapper contentWrapperSmoothRelease report-modern-page multi-asset-visit-report-page` : `contentWrapper contentWrapperSmooth report-modern-page multi-asset-visit-report-page`}>
            <div className="reportHeaderTile">
              <div className="headingContainer report-modern-header">
                <div>
                  <h2 className="mainHeading">
                    Multi Asset Visit Report
                  </h2>
                  <p>Compare visit paths, depot positions and stop activity for up to 10 selected assets on one map.</p>
                </div>
                <i className={this.props.headerHide ? `fa fa-window-restore` : `fa fa-window-maximize`} onClick={this.handleWindow} />
              </div>
              <div className="inputFormGroup reportPickerGrid reportPickerToolbar">
                <div className="inputElement reportPickerField">
                  <label>Group</label>
                  <DropDownSearch
                    caption={this.state.selectedGroupName}
                    icon="fa-truck"
                    values={this.state.groupData}
                    onParentCall={this.handleGroupSelect}
                  />
                </div>
                <div className="inputElement reportPickerField reportPickerFieldWide">
                  <label>Assets</label>
                  <MultiDropDown
                    assetData={this.state.assetData}
                    onParentCall={this.handleAssetSelect}
                    selectGroupId={this.state.selectGroupId}
                    modern
                    placeholder={this.state.selectGroupId ? "Select up to 10 assets" : "Select group first"}
                  />
                </div>
                <div className="inputElement reportPickerField">
                  <label>Date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction}
                    dropDown={calendarReport}
                    placeholder={this.state.dataPlaceholder}
                    icon="fa-calendar"
                  />
                </div>
                <div className="inputElement reportPickerActions">
                  {canCreateReport ? (
                    <Button className={hasPendingReportChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"} variant="primary" onClick={this.handleCreateReport} size="sm">
                      <i className="fa fa-map-marker"></i>
                    Create Report
                  </Button>
                ) : (
                    <Button className="reportPickerCreateButton" variant="primary" onClick={this.handleCreateReport} size="sm" disabled>
                      <i className="fa fa-map-marker"></i>
                    Create Report
                  </Button>
                )}
                </div>
              </div>
            </div>
            <div className="reportBody">
              {this.state.reportLoader ? (
                <div className="loaderLine">
                  <br />
                  <GridLoader size={7} color={"#222222"} loading={this.state.reportLoader} />
                  <h1> &nbsp;Generating Report</h1>
                  <br />
                </div>
              ) : (
                <React.Fragment>
                  <React.Fragment>
                    {this.state.showContent && (
                      <div className="containerMap">
                        <MultiVisitMap
                          key={`multi-visit-map-${this.state.reportVersion}`}
                          ref={(mapRef) => {
                            this.mapRef = mapRef;
                          }}
                          depots={this.state.depots}
                          finalDataArr={this.state.finalDataArr}
                          redraw={this.state.redraw}
                          assetControls={assetMapControls}
                          onResetMap={() => this.setState({ focusedAssetId: "", redraw: false })}
                        />
                      </div>
                    )}
                  </React.Fragment>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(Multiasset);
